import { useState } from 'react';
import { ModalFooter, Button, Spinner, Row, Col } from 'reactstrap';
import { FaPlus } from 'react-icons/fa';
import SpinnerContainer from '../Utilities/Ui/SpinnerContainer';
import useLocalStorage from "../Utilities/Hooks/useLocalStorage";
const ItemFooter = ({ itemPopup, handleItemDeletePopup, handleItemSubmit, handleItemPopupClose, handleOpenActionPopup, handleOpenMaintenancePlanPopup, itemPopupHeader, Section, saving }) => {
    const [roleName, setRoleName] = useState(localStorage.getItem("roleName"));
    const [farmRoleName, setFarmRoleName] = useLocalStorage('farmRoleName', null);
    //const isAddArchiveItem = localStorage.getItem("isAddArchiveItem");
    //const isCreateNewAction = localStorage.getItem("isCreateNewAction");
    //const saveRightsForNonItemFieldsAndTables = localStorage.getItem("saveRightsForNonItemFieldsAndTables");
    return (
        <ModalFooter className="justify-content-between">
            {itemPopupHeader != undefined && itemPopupHeader.page == 'Irrigation' && itemPopupHeader.itemTypeName == 'Water Take' &&
                <><div></div><div><Button color="primary" onClick={handleItemPopupClose} size="sm">Cancel</Button> </div></>
            }
            {itemPopupHeader == undefined &&
                <>
                <div>
                    {(roleName == 'SWNZ Admin' || farmRoleName == 'SWNZ Admin' || farmRoleName == 'Manager') &&
                            <>
                        {itemPopup.itemId !== 0 && Section != 'Community & Cultural Significance' && !itemPopup.isMapOnly &&
                                <Button color="primary" onClick={(itemId) => handleOpenActionPopup(itemPopup.itemId)} size="sm">
                                    <FaPlus /> Action
                                </Button>}
                                {' '}
                            </>
                    }
                    </div>
                <div>
                    {(roleName == 'SWNZ Admin' || farmRoleName == 'SWNZ Admin' || farmRoleName == 'Manager') &&
                        <>
                        {itemPopup.itemId !== 0 &&
                            <>  {itemPopup.canArchive &&
                                <>
                                    <Button color="danger" onClick={(itemId) => handleItemDeletePopup(itemPopup.itemId)} size="sm">Archive</Button>{' '}
                                </>
                                }
                            </>}
                        </>
                    }
                    {(roleName == 'SWNZ Admin' || farmRoleName == 'SWNZ Admin' || farmRoleName == 'Manager') &&
                        <>
                            {saving ?
                                <>
                                <Button onClick={handleItemSubmit} color="success" disabled size="sm">
                                    <Row>
                                        <Col sm="6">
                                            <span>
                                                {' '}Saving
                                            </span>
                                        </Col>
                                        <Col sm="6">
                                            <Spinner size="sm">
                                                Saving...
                                            </Spinner>
                                        </Col>
                                    </Row></Button>{' '}
                                </>
                            :
                                <>
                                    <Button onClick={handleItemSubmit} color="success" size="sm">
                                        Save
                                    </Button>{' '}
                                </>
                            }
                        </>
                    }       
                        <Button color="primary" onClick={handleItemPopupClose} size="sm">Cancel</Button>
                    </div>
                </>
            }
            {itemPopupHeader != undefined && itemPopupHeader.page == 'Irrigation' && itemPopupHeader.itemTypeName != 'Water Take' &&
                <>
                <div>
                    {(roleName == 'SWNZ Admin' || farmRoleName == 'SWNZ Admin' || farmRoleName == 'Manager') &&
                            <>
                            {itemPopup.itemId !== 0 &&
                                <Button color="primary" onClick={(itemId) => handleOpenActionPopup(itemPopup.itemId)} size="sm">
                                    <FaPlus /> Action
                                </Button>}{' '}
                        </>
                    }
                    </div>
                <div>
                    {(roleName == 'SWNZ Admin' || farmRoleName == 'SWNZ Admin' || farmRoleName == 'Manager') &&
                        <>
                            {itemPopup.itemId !== 0 &&
                            <>
                            {itemPopup.canArchive &&
                                <>
                                    <Button color="danger" onClick={(itemId) => handleItemDeletePopup(itemPopup.itemId)} size="sm">Archive</Button>
                                    {' '}</>
                            }
                                </>
                            }
                        </>
                    }
                    {(roleName == 'SWNZ Admin' || farmRoleName == 'SWNZ Admin' || farmRoleName == 'Manager') &&
                        <>
                        {saving ?
                            <>
                                <Button onClick={handleItemSubmit} color="success" disabled size="sm">
                                    <Row>
                                        <Col sm="6">
                                            <span>
                                                {' '}Saving
                                            </span>
                                        </Col>
                                        <Col sm="6">
                                            <Spinner size="sm">
                                                Saving...
                                            </Spinner>
                                        </Col>
                                    </Row></Button>{' '}
                            </>
                            :
                            <>
                                <Button onClick={handleItemSubmit} color="success" size="sm">
                                    Save
                                </Button>{' '}
                            </>
                        }
                        </>
                    }
                        <Button color="primary" onClick={handleItemPopupClose} size="sm">Cancel</Button>
                    </div>
                </>
            }
        </ModalFooter>
    )
}
export default ItemFooter